export default __webpack_public_path__ + "static/media/img_2_thumb.553405f0.JPG";